import React from 'react'
import cx from 'classnames'

export default function MainCard({ label, title, img, cardSlide, onClick }) {
  const classes = cx({
    "hover:border hover:shadow-costumeShadow": cardSlide ? false : true,
    border: cardSlide ? true : false,
  });
  return (
    <div
      className={`py-10 transition-all duration-100 cursor-pointer rounded-2xl border-borderCardFeatures px-9 ${classes}`}
      onClick={onClick}
    >
      <div className="cardImage rounded-2xl">
        <img
          crossOrigin='anonymous'
          src={img}
          alt="cardImage"
          height={389}
          className="w-full rounded-2xl h-[200px]"
        />
      </div>
      <span className="block my-8 text-base font-semibold cardLabel text-phoneColor">
        {label}
      </span>
      <h1 className="font-bold cardTitle text-cardText">{title}</h1>
    </div>
  );
}
